import React, { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";

import Button, { ButtonTypes } from "../../../../components/Button";
import { countryOptionOf } from "./constants";
import { CountryField } from "./CountryField";
import {
  EditorActions,
  EditorError,
  EditorForm,
  FixSection,
  FixSectionTitle,
} from "./styles";
import { SourceCountrySectionProps, SourceCountryValues } from "./types";

export const SourceCountrySection: React.FC<SourceCountrySectionProps> = ({
  instrument,
  isSubmitting,
  error,
  draft,
  onDraftChange,
  onSave,
}) => {
  const prefilled = countryOptionOf(instrument.sourceCountry);
  const { control, handleSubmit } = useForm<SourceCountryValues>({
    defaultValues: draft ?? { country: prefilled },
  });
  const country = useWatch({ control, name: "country" });

  const chosenCode = country?.value ?? null;
  // A stored code outside COUNTRY_OPTIONS prefills empty, so an untouched field must not send that as a clear.
  const isChanged = chosenCode !== (prefilled?.value ?? null);

  useEffect(() => {
    onDraftChange?.(isChanged ? { country } : null);
  }, [isChanged, country, onDraftChange]);

  const submit = () => onSave(chosenCode);

  return (
    <FixSection aria-label="Source country">
      <FixSectionTitle>Source country</FixSectionTitle>
      <EditorForm noValidate onSubmit={handleSubmit(submit)}>
        <CountryField
          control={control}
          label="Country"
          disabled={isSubmitting}
        />
        {error && <EditorError role="alert">{error}</EditorError>}
        <EditorActions>
          <Button
            type={ButtonTypes.primary}
            buttonType="submit"
            disabled={!isChanged}
            isLoading={isSubmitting}
          >
            Save country
          </Button>
        </EditorActions>
      </EditorForm>
    </FixSection>
  );
};
